module.exports = __webpack_public_path__ + "img/icon-add-red.cb26faaa.svg";